import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const DemonstrationActivities = () => {
  const data = [
    ['Activity', 'Count'],
    ['Strategy Implementation', 10],
    ['SOP Compliance', 15],
  ];

  const options = {
    title: 'Demonstration Activities',
    pieHole: 0.4,
    slices: [
      { color: '#4CAF50' },
      { color: '#FF9800' },
    ],
    legend: { position: 'right' },
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="PieChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default DemonstrationActivities;